import { render, staticRenderFns } from "./ProjectView.vue?vue&type=template&id=b91533f6&scoped=true"
import script from "./ProjectView.vue?vue&type=script&lang=js"
export * from "./ProjectView.vue?vue&type=script&lang=js"
import style0 from "./ProjectView.vue?vue&type=style&index=0&id=b91533f6&prod&lang=css"
import style1 from "./ProjectView.vue?vue&type=style&index=1&id=b91533f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91533f6",
  null
  
)

export default component.exports